import {
  Component,
  ViewChild,
  ElementRef,
  ViewEncapsulation,
  AfterViewInit,
  ChangeDetectionStrategy,
  OnInit,
  Sanitizer,
  ChangeDetectorRef,
  OnDestroy,
  Renderer2,
  HostListener,
} from "@angular/core";
import { VERSION } from "@angular/material/core";
import { MatSidenav, MatDrawer } from "@angular/material/sidenav";
import { NavService } from "../services/nav.service";
import { UserAuthentication } from "../interfaces/user-authentication";
import { UserAuthenticationServices } from "../services/user-authentication.services";
import { DialogService } from "../services/dialog.service";
import { UserFormConfigComponent } from "../forms/usuarios/user-form-config/user-form-config.component";
import { OverlayContainer } from "@angular/cdk/overlay";
import { ThemeService } from "../services/theme.service";
import { DomSanitizer } from "@angular/platform-browser";
import { environment } from "src/environments/environment";
import { ObjectUtil } from "../system-utils/utils/ObjectUtil";
import { ItensMenu, Role, RolePermission } from "../interfaces/RolePermission";
import { NotificationsService } from "../services/notifications.service";
import { Notification } from "../interfaces/notifications";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { BehaviorSubject, Observable, Subject, Subscription, debounceTime, distinctUntilChanged, filter, map, switchMap, takeUntil } from "rxjs";
import { HTTPService } from "src/app/services/http.service";
import { MenuServices } from "../services/menu-service.services";
import { MatTab, MatTabChangeEvent, MatTabGroup, MatTabNav, MatTabNavPanel } from "@angular/material/tabs";
import { TabService } from "../services/tab.service";
import { NavItem } from "../interfaces/nav-item";
import { Router, NavigationEnd } from "@angular/router";
import { FormBuilder, FormGroup } from "@angular/forms";

import { PermissionServices } from "../services/permission.services";
import { StringUtils } from "../system-utils/utils/StringUtils";
import { LanguageServices } from "../services/LanguageServices";
import { DynamicLoaderService } from "../services/dynamic-loader.service";
import { NzModalService } from "ng-zorro-antd/modal";
import { DashboardFocusService } from "src/app/services/dashboard-focus.service";
import { NzTabChangeEvent } from "ng-zorro-antd/tabs";



@Component({
    selector: "app-system-view",
    templateUrl: "./system-view.component.html",
    //encapsulation:ViewEncapsulation.None,
    styleUrls: ["./system-view.component.scss"],
    providers: [
        // Provide a value to be used by Angular's dependency injection
        // machanism to pass 
        { provide: 'navItens', useValue: 'navItems' },
    ],
    animations: [
        trigger("inOutAnimation", [
            transition(":enter", [
                style({ height: 0, opacity: 0, position: "absolute" }),
                animate("1s ease-out", style({ height: 300, opacity: 1 })),
            ]),
            transition(":leave", [
                style({ height: 300, opacity: 1, position: "absolute" }),
                animate("1s ease-in", style({ height: 0, opacity: 0 })),
            ]),
        ]),
        trigger('changeState', [
          state('inactive', style({ backgroundColor: 'red', transform: 'scale(1)' })),
          state('active', style({ backgroundColor: 'green', transform: 'scale(1.2)' })),
          transition('inactive <=> active', animate('300ms ease-in-out'))
        ])
    ],
    standalone: false
},
)
export class SystemViewComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("sidenav") sidenav: MatSidenav;
  //@ViewChild('tabgroup') tabgroup:MatTabNav;
  @ViewChild('tabgroup') tabgroup:MatTabGroup;
  tipo: String = "";
  version = VERSION;
  userName: string = "Admin";
  companyName: string = "Tem API";
  ua: UserAuthentication;
  isDarkTheme: Observable<Boolean> = new Observable<Boolean>() ;
  img;
  useAvatar = false;
  versionApp: string = environment.versionApp;
  sub: Subscription;
  firstLoad = true;
  navItems: NavItem[] = [];
  useTab:boolean = false;
  locked:boolean = false;
  showRecorder:boolean = false;
  canViewRec:boolean = true;
  //tabs = [];
  selectedTab:any = null;
  activeLink = null;
  linksRoute:Observable<{IDMENU:string, DESCRIPTION:string, svgIconName:string, iconName:string}[]> = new Observable();
  currentTab:BehaviorSubject<any> = new BehaviorSubject<any>({});
  formLink:FormGroup;
  hasActiveRoute: boolean = false;
  selectedTabIndex: number = 0; // 0 = Dashboard, 1 = Routes

  @ViewChild('inputResourceFinder') inputResourceFinder:ElementRef;
  //sidenavSmall:boolean = true;

  constructor(

    public navService: NavService,
    public UserAuthenticationServices: UserAuthenticationServices,
    private dialogService: DialogService,
    private overlayContainer: OverlayContainer,
    private themeService: ThemeService,
    private sanitizer: DomSanitizer,
    private cd: ChangeDetectorRef,
    private http: HTTPService,
    private MenuServices: MenuServices,
    public tabService: TabService,
    private router:Router,
    private ap:PermissionServices,
    private ls:LanguageServices,
    private modal:NzModalService,
    private dfs:DashboardFocusService,
    private formBuilder:FormBuilder,
    private dynamicLoader: DynamicLoaderService
  ) {
    

    
    this.useTab = this.UserAuthenticationServices.user.usetab == null ? false :
                    this.UserAuthenticationServices.user.usetab == 'S' ? true:false;


    
    this.formLink = formBuilder.group({
        linkName:''
    });

    this.linksRoute = this.formLink.get('linkName')!.valueChanges.pipe(
      distinctUntilChanged(),
      debounceTime(1000),
      filter((linkName) => !!linkName),
      switchMap(linkName => this.getMenuByName(linkName))
    );
    
    this.ua = JSON.parse(localStorage.getItem("user"));
    this.companyName = this.ua.companyname;
    this.userName = this.ua.username;

  }


  ngOnDestroy(): void {
    if (this.sub != null) {
      this.sub.unsubscribe();
    }
  }

  async loadPermissions() {
    await Promise.all(this.MenuServices.promiseMenuArr); //espera terminar a recursão da montagem dos menus para casar as permissões. Verificar se depois temos que mover para outro lugar pelo delay.

    if (this.firstLoad) {
      this.navItems = JSON.parse(JSON.stringify(this.MenuServices.navItems));
      this.firstLoad = false;
    }

    this.disableAll(this.navItems);
    
    if (ObjectUtil.isNotEmpty(this.ua.permission)) {
      this.ua.permission.forEach((p: RolePermission) => {
        if (ObjectUtil.isNotEmpty(p.ROLE)) {
          let role: Role = JSON.parse(p.ROLE.toString()) as Role;
          this.disableAll(this.navItems);
          if (ObjectUtil.isNotEmpty(role.menu)) {
            if (Array.isArray(role.menu)) {
              role.menu.forEach((menu) => {
                this.findMenu(this.navItems, menu);
              });
            }
          }
        }
      });
    }
  }

  async loadMenu() {
    return new Promise((resolve,reject)=>{
      this.MenuServices.getMenus().then(async (x) => {
        await this.loadPermissions();
        this.tabService.findRecursive(this.navItems);
        this.tabService.matTabGroup = this.tabgroup;
        resolve(true)
        //this.tabs = this.tabService.tabs;
      });
    });
    
    
  }

  disableAll(navItem: NavItem[]) {
    navItem.forEach((nav) => {
      if (nav.children != null && nav.children.length > 0) {
        this.disableAll(nav.children);
        nav.visible = false;
        nav.hidden = false;
        nav.expanded = false;
      } else {
        nav.visible = false;
        nav.expanded = false;
        nav.hidden = false;
      }
    });
  }

  findMenu(navItem: NavItem[], menu: ItensMenu) {
    navItem.forEach((nav) => {
      if (
        (nav.id == menu.id && menu.route == null) ||
        (nav.route == menu.route && menu.route != null)
      ) {
        nav.visible = menu.visible == null ? false : menu.visible;
      } else {
        if (nav.children != null && nav.children.length > 0) {
          this.findMenu(nav.children, menu);
        }
      }
    });
  } 

  loadImage() {
    if (this.ua.useravatar != null) {
      let objectURL = "data:image/png;base64," + this.ua.useravatar;
      this.img = this.sanitizer.bypassSecurityTrustUrl(objectURL);
      this.useAvatar = true;
    }
  }

  async ngOnInit(): Promise<void> {

    try{
      this.ls.setDefaultLanguage();
      this.isDarkTheme = this.themeService.isDarkTheme;
      
      this.isDarkTheme.subscribe(dadata=>{
          localStorage.setItem('darkTheme',String(dadata));
      });

      this.canViewRec = this.ap.checkPermission('Mktpmedia').canInsert;
      this.loadMenu().then(d=>{
        this.locked =  localStorage.getItem('menu-locked')==null? false :  StringUtils.stringToBoolean(localStorage.getItem('menu-locked'));
        let language= localStorage.getItem('language')==null?'pt-BR': localStorage.getItem('language');
        setTimeout(()=>this.changeLanguage(language));
      });

      this.loadImage();
      this.loadTabs();
      this.dfs.setFocus(false);

      
        
  
      // // Rastrear mudanças de rota para controlar aba
      this.router.events.pipe(
        filter((event: any) => event instanceof NavigationEnd),
        debounceTime(100)
      ).subscribe((event: NavigationEnd) => {
        const currentUrl = event.url;
        // Se é home, mostra dashboard (aba 0), senão mostra routes (aba 1)
        const isHome = currentUrl === '/' || currentUrl === '/home' || currentUrl === '';
        this.selectedTabIndex = isHome ? 0 : 1;
        this.hasActiveRoute = !isHome;
      });

      // // Inicializar o estado
      const currentUrl = this.router.url;
      const isHome = currentUrl === '/' || currentUrl === '/home' || currentUrl === '';
      this.selectedTabIndex = isHome ? 0 : 1;
      this.hasActiveRoute = !isHome;

    }catch(Exception ){
      this.UserAuthenticationServices.gotoLogin();
    }
    

  }
  loadTabs() {
    this.tabService.loadTabs();
  }

  
  ngAfterViewInit() {
    this.navService.appDrawer = this.sidenav;
    
    setTimeout(()=>{
      if (this.ua.layout != null) {
        this.change(this.ua.layout);
      }    
    },0)


    // if (this.tabService.tabs && this.tabService.tabs.length > 0) {
    //   const first = this.tabService.tabs[0];
    //   this.router.navigate([first.url], { skipLocationChange: true });
    // }
  }

  toggle(tipo: String) {
    this.tipo = tipo;
    //this.sidenav.opened ? this.sidenav.close() : this.sidenav.open();
    if ( tipo == 'close' && !this.locked){
      this.navService.sidenavSmall = true;
    }else{
      this.navService.sidenavSmall = false;
    }
    //this.sidenavSmall = !this.sidenavSmall;
    if( this.navService.sidenavSmall){
      this.navItems.forEach((val,index,array)=>{
        
        if ( val.children!= null ){
          val.children.forEach(d=>{d.hidden = true});
        }
      });
    }else{
      this.navItems.forEach((val,index,array)=>{
        if ( val.children!= null ){
          val.children.forEach(d=>d.hidden = false);
        }
      });
    }
  }

  toggleSider() {
    this.navService.sidenavSmall = !this.navService.sidenavSmall;
    if (this.navService.sidenavSmall) {
      this.navItems.forEach((val, index, array) => {
        if (val.children != null) {
          val.children.forEach(d => { d.hidden = true });
        }
      });
    } else {
      this.navItems.forEach((val, index, array) => {
        if (val.children != null) {
          val.children.forEach(d => d.hidden = false);
        }
      });
    }
    this.saveOption(this.navService.sidenavSmall);
  }

  
  close(tipo: String) {
    this.tipo = tipo;
    this.sidenav.close();
  }

  backToDashboard() {
    this.router.navigate(['/home'],{ skipLocationChange: true });
    this.dfs.setFocus(true);
  }

  backToRoute(){
    if ( this.tabService.tabs.length > 0){
      this.router.navigate([this.tabService.tabs[this.tabService.tabs.length-1].url],{ skipLocationChange: true });
    }else{
      this.router.navigate(['/home'],{ skipLocationChange: true });
    }
    this.dfs.setFocus(false);
  }

  logout() {
    this.tabService.tabs = [];
    this.UserAuthenticationServices.logout();
  }

  reload(data) {
    this.ua = JSON.parse(localStorage.getItem("user"));
    if (this.ua.layout != null) {
      this.change(this.ua.layout);
    }

    this.loadImage();
    this.cd.detectChanges();
  }

  openConf() {
     const modalRef = this.modal.create({
      nzTitle: this.ls.instant('systemView.userConfig'),
      nzContent: UserFormConfigComponent,
      nzWidth: '80vw',
      nzFooter: null,
      nzMaskClosable: false,
      nzCentered: true,
      nzBodyStyle: { display: 'flex', overflow: 'auto' , height:"80vh", width:"100%"},
      nzClosable: true,
      nzData: {
        user: this.ua
      }
    });

    // reaplica avatar/nome/paleta salvos no user-form-config (sem F5)
    modalRef.afterClose.subscribe(() => this.reload(null));
  }

  private setOverlayClass() {
    this.overlayContainer
      .getContainerElement()
      .classList.add("theme-alternate");
  }

  private removeOverlayClass() {
    this.overlayContainer
      .getContainerElement()
      .classList.remove("theme-alternate");
  }

  change(event: string) {
    if (event == "dark") {
      this.themeService.setDarkTheme(true);
      this.setOverlayClass();
    } else {
      this.removeOverlayClass();
      this.themeService.setDarkTheme(false);
    }
  }
  
  closeTab(index:number, event: Event) {
    
    setTimeout(()=>{
      this.router.navigate([this.tabService.tabs[index].url], { skipLocationChange: true });
      this.tabService.deleteTab(index);
      setTimeout(()=>{
        if( (index-1) < 0){
      
          if ( this.tabService.tabs.length >0){
            this.router.navigate([this.tabService.tabs[0].url], { skipLocationChange: true });
          }else{
            this.router.navigate([""], { skipLocationChange: true });
          }
          
        }else{
          this.router.navigate([this.tabService.tabs[index-1].url], { skipLocationChange: true });
        }    
      })
    })
    
    event.preventDefault();
  }

  changeLanguage(language: string) {
    
    this.ls.changeLanguage(language).then((d) => {
      this.cd.detectChanges();
    });
    
  }
  
  saveOption(locked){
      localStorage.setItem("menu-locked",locked);
  }


  onTabChange(index: number) {
     const tab = this.tabService.tabs[index];
      if (!tab || !tab.url) {
        console.warn('Tab sem URL para índice', index, tab);
        return;
      }

      // se as rotas são filhas de SystemViewComponent:
      this.router.navigate([tab.url], { skipLocationChange: true });
        
    
  }

  // navigate(tab){
  //   this.router.navigate([tab.url], { skipLocationChange: true });
  // }

  // displayFn(route): string {
  //   return route && route.DESCRIPTION ? route.DESCRIPTION : '';
  // }

  trackByRoute(index: number, route: any): any {
     return route?.IDMENU || index;
  }

  getMenuByName(name):Observable<{IDMENU:string, DESCRIPTION:string, svgIconName:string, iconName:string}[]>{
      let ob = {
          "entityName":"Mktpmenu",
          "sql":`SELECT DISTINCT MKTPMENU.* FROM MKTPMENU INNER JOIN MKTPMENUACESS ON MKTPMENU.NUMENU = MKTPMENUACESS.NUMENU
            WHERE ISNULL(MKTPMENU.TYPE,'')!='R' 
            AND (SOUNDEX(MKTPMENU.DESCRIPTION) = SOUNDEX('${name}') OR MKTPMENU.DESCRIPTION LIKE '%${name}%')
            AND ${this.UserAuthenticationServices.user.profile=='ADMIN' ? '0=0': "MKTPMENUACESS.IDUSER= "+this.UserAuthenticationServices.user.iduser}`
      };

      return this.http.postGeneric<{IDMENU:string, DESCRIPTION:string, svgIconName:string, iconName:string}[]>(ob,'JsonBrokerServices/findnative',false,true,false).pipe(
          map(list=>{
            let info =  list['SQL'];
            let array:{IDMENU:string, DESCRIPTION:string,svgIconName:string, iconName:string}[]  = [];
            for ( var l of info ){
                let properties = JSON.parse(l.PROPERTIES);
                let svgIconName = properties['svgIconName'];
                let iconName = properties['iconName'];
                
                array.push( {IDMENU:l.IDMENU, DESCRIPTION: l.DESCRIPTION, svgIconName: svgIconName, iconName: iconName});
            }
            return array;
          })
      )
  }

  onSelectItem($event: any){
    // ng-zorro emite o evento com a opção
    const value = $event?.nzValue || $event;

    let navItem:NavItem = {
        displayName:'dummy',
        expanded:false,
        hidden:false,
        id:'0',
        nuMenu:value,
        route:value,
        visible:false,
        level:0
    }

    this.navService.selectItem(navItem, this.useTab, this.router, this.tabService, value, this.UserAuthenticationServices.user.iduser);
    // Limpar o campo após seleção
    this.formLink.get('linkName')?.reset();
  }

  @HostListener('window:keydown.control.k', ['$event'])
  public onKeyUp(event: KeyboardEvent): void {
    event.preventDefault();
    this.inputResourceFinder.nativeElement.focus();
  }

  trackByUrl(index: number, tab: any) {
    return tab.url;
  }

  // backToDashboard(){
  //   this.hasActiveRoute = false;
  // }

  // backToRoute(){
  //   this.hasActiveRoute = true;
  // }
} 

